import React from 'react'
import { useSearchParams } from 'react-router-dom'
import { AuthElement } from "@tap-payments/auth-jsconnect"

export default function Auth() {
  const [searchParams] = useSearchParams()
  const scope = searchParams.get("scope") ?? 'auth'
  const mode = searchParams.get("mode") ?? 'popup'
  const countryCode = searchParams.get("country_code") ?? ''
  const postUrl = searchParams.get("postUrl") ?? 'https://203zq.wiremockapi.cloud/json'

	return (
		<AuthElement
			open={true}
			scope={scope}
      mode={mode as any}
      merchantDomain={window.location.origin}
			publicKey='pk_test_lat64TEDSvHrUOYAxVRe28PQ'
			appInfo={{
        name: "Tap Connect Demo"
      }}
      data={['individual']}
      postURL={postUrl}
			businessCountryCode={countryCode}
			language={"en" as any}
      onError={(error: any) => {
        console.log(JSON.stringify({ error }))
      }}
      onFlowCompleted={(res: any) => console.log("onFlowCompleted", res)}
		/>
	)
}
